module.exports = __webpack_public_path__ + "img/skip-cleaning-w.svg";